'use client';

import React, { useState } from 'react';

function FAQItem({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-xl overflow-hidden" style={{ backgroundColor: 'var(--surface)', border: '1px solid var(--border-color)' }}>
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-5 py-4 text-left hover:opacity-80 transition-opacity"
        aria-expanded={open}
      >
        <span className="text-sm font-semibold pr-4" style={{ color: 'var(--text)' }}>{q}</span>
        <span className="text-lg leading-none flex-shrink-0 transition-transform duration-200" style={{ color: 'var(--text-muted)', transform: open ? 'rotate(180deg)' : 'none' }}>
          ‹
        </span>
      </button>
      {open && (
        <div className="px-5 pb-4">
          <p className="text-sm leading-relaxed" style={{ color: 'var(--text-muted)' }}>{a}</p>
        </div>
      )}
    </div>
  );
}

export default function OnSiteFAQ({ faqs }: { faqs: { q: string; a: string }[] }) {
  return (
    <div className="space-y-2">
      {faqs.map((faq, i) => (
        <FAQItem key={i} q={faq.q} a={faq.a} />
      ))}
    </div>
  );
}
